export default "__VITE_ASSET__Ss0p6Zi8__"